export default __webpack_public_path__ + "static/media/cover1.66692e21.jpg";